import { executeRequest, Request } from '@jfs/network'
import { Config } from 'react-native-config'
import { simpleDateFormat } from '../util/billPaymentUtil'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'
import { returnExtraInfo } from './getBillfetch'

export const statusMap = {
  S: 'SUCCESS',
  SUCCESS: 'SUCCESS',
  P: 'PENDING',
  PENDING: 'PENDING',
  RECHECK: 'RECHECK',
  F: 'FAILED',
  FAILED: 'FAILED',
  CONFIRMED: 'CONFIRMED',
}

const SUCCESS = 'SUCCESS'
const PENDING = 'PENDING'
const FAILURE = 'FAILURE'

export const getStatusUnion = (orderData: any) => {
  const fulfillmentStatus = orderData?.fulfilment?.status?.toUpperCase()
  const paymentStatus = orderData?.payment?.status?.toUpperCase()
  if (fulfillmentStatus === SUCCESS) {
    if (paymentStatus === SUCCESS) {
      return SUCCESS
    } else if (paymentStatus === PENDING) {
      return PENDING
    } else if (paymentStatus === FAILURE) {
      return FAILURE
    }
  } else if (fulfillmentStatus === PENDING) {
    return PENDING
  } else {
    return FAILURE
  }
}

export const responseParser = (data: any) => {
  if (data?.responseStatus?.code === '000') {
    const responseData = data?.responseObject[0]?.order
    const paymentStatus = getStatusUnion(responseData)
    const status: string = statusMap[paymentStatus as keyof typeof statusMap] ?? statusMap.F
    const res = {
      errorCode: data?.errorCode,
      customerAccountId: responseData?.beneficiary?.id,
      errorMessage: responseData?.errorMessage ?? '',
      message: data?.message ?? '',
      status: status,
      responseObj: responseData ?? [],
    }

    const resObj = res?.responseObj ?? {}
    const paymentObject = resObj?.payment ?? {}

    const metaData = resObj?.product?.metaData?.bpAuthenticator
    const billMetaDate = returnExtraInfo(metaData, resObj?.payment?.id)
    //const producExtraInfo = returnExtraInfo([extraInfo], resObj?.payment?.id)
    let paymentExtraInfo = []
    try {
      if (paymentObject?.hasOwnProperty('status')) {
        let bankName = paymentObject?.account?.bankName
        if (paymentObject?.paymentInstrument === 'CREDIT CARD' || paymentObject?.paymentInstrument === 'DEBIT CARD') {
          bankName = paymentObject?.account?.card?.maskedNumber
        }
        paymentExtraInfo = returnExtraInfo(
          [
            { name: 'Debited From', value: bankName },
            { name: 'Product Name', value: resObj?.product?.name },
            { name: 'Payment Mode', value: paymentObject?.paymentInstrument },
            { name: 'Transaction ID', value: paymentObject?.paymentProcessorRefNo },
            { name: 'Customer Convenience Fee', value: `${paymentObject?.chargeAmount}` },
          ],
          resObj?.payment?.id,
        )
      }
    } catch (error) {
      console.log('extra info parsing error', error)
    }
    const extraInfos = [...billMetaDate, ...paymentExtraInfo]

    const txn = {
      status: status ?? 'FAILED',
      message: res?.message ? res.message : res?.errorMessage,
      timeStamp: paymentObject?.paymentAt ?? simpleDateFormat(new Date(), 'yyyy-MM-ddTHH:mm:ss'),
      txnId: resObj?.payment?.id,
      txnMetaData: {
        bbpsRefNo: resObj?.product?.bbpsRegNo ?? '',
        errorMessage: resObj?.errorMessage ?? '',
        billConfirmationNumber: resObj?.product?.metaData?.bpAuthenticator?.[0]?.value,
        bill: {
          extraInfos: extraInfos,
          authenticators: resObj?.product?.attribute?.authenticatorList,
          beneficiaryId: resObj?.beneficiary?.id,
        },
      },
    }
    return { res, txn }
  } else {
    console.log('Tranasction Status Error', data)
    let trxStatus: String = PENDING
    if (data?.error?.code === statusMap.RECHECK) {
      trxStatus = PENDING
    }

    const errorMsg = {
      errorCode: data?.error?.code,
      errorMessage: data?.error?.message,
      status: trxStatus,
    }
    throw errorMsg
  }
}

const returnStatusBody = (txnRefNo: string) => {
  return {
    order: {
      id: txnRefNo,
    },
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'This is for the buy case',
    },
    initiatingEntity: {
      entityId: Config.REACT_APP_CHANNEL_ID,
      channelId: Config.REACT_APP_CHANNEL_ID,
    },
  }
}

export const checkPaymentStatus = (tokens: any, userAccessToken: any, txnRefNo: string) => {
  const config = sitConfig(tokens)
  const request: Request<{}> = {
    apiPath: APIEndPoints.checkPaymentStatus,
    method: 'POST',
    body: returnStatusBody(txnRefNo),
    config: config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    //console.log('executeRequest Error', data)
    return responseParser(data?.data)
  })
}
